<template>
    <v-dialog :value="modal_test.active" lazy max-width="600">
        <v-card class="pa-4">
            <v-icon class="modal-close" @click.native="CLOSE_MODAL('test')" aria-hidden="true" translate="no">close</v-icon>
            <v-card-title class="display-1">{{ $t(modal_test.modal_title) }}</v-card-title>
            <v-card-text class="title mt-4">{{ course_name }}</v-card-text>
            <div v-if="expired" class="my-3">{{ $t("Время для прохождения курса истекло, вы не получите баллы за тест") }}</div>
            <v-layout row wrap
                      pa-3
                      mb-4
                      mt-3
            >
                <v-flex xs12 sm6>
                    <v-layout align-center>
                        <v-flex
                          class="xs6"
                          v-html="$t('Проходной балл {lineBreak}{scoreRequired} из {scoreMax}', {
                            lineBreak: '<br>',
                            scoreRequired: points_required_test,
                            scoreMax: points_total_test,
                          })"
                        />
                        <v-flex>
                            <v-progress-circular
                                :rotate="-90"
                                :size="64"
                                :width="6"
                                :value="percent(points_required_test,points_total_test)"
                                class="grey-text"
                            >
                                {{ percent(points_required_test,points_total_test) }}%
                            </v-progress-circular>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 sm6 :class="{'mt-4': $vuetify.breakpoint.xs}">
                    <v-layout xs12 sm6 align-center>
                        <v-flex class="xs6"
                          v-html="$t('Ограничение {lineBreak}по времени', {
                            'lineBreak': '<br>',
                          })"
                        />
                        <v-flex>
                            <v-progress-circular
                                :rotate="-90"
                                :size="64"
                                :width="6"
                                :value="0"
                            >
                                {{ time_test }}<br>{{ $t("мин") }}
                            </v-progress-circular>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-card-actions>
                <v-layout row wrap>
                    <buttonRed :class="{'flex xs12 mr-0': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}" @click.native="show_test">{{ $t("Начать") }}</buttonRed>
                    <buttonBdWhite :class="{'flex xs12 mt-3': $vuetify.breakpoint.xs}" @click.native="CLOSE_MODAL('test')">{{ $t("Отмена") }}</buttonBdWhite>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import buttonRed from '@/components/ui/buttons/button_red';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    buttonRed,
    buttonBdWhite,
  },
  props: {
    modal_type: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters('cards', ['cards', 'get_card_by_id']),
    ...mapGetters('course_info', [
      'snackbar',
      'course_completed',
      'test_started',
      'course_name',
      'points_required_test',
      'points_total_test',
      'time_test',
      'expired',
      'test_remain_in_seconds',
    ]),
    ...mapGetters('course_info/modals', [
      'modal_success',
      'modal_failed',
      'modal_test',
    ]),
  },
  methods: {
    ...mapMutations('course_info', [
      'DISABLE_SNACKBAR',
      'TOGGLE_SNACKBAR',
      'COMPLETE_COURSE',
      'START_TEST',
    ]),
    ...mapMutations('course_info/modals', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    ...mapMutations('course_info/steps', [
      'RESET_LESSONS',
    ]),
    ...mapMutations('testing/questions', [
      'SHOW_RESULTS',
    ]),
    ...mapActions('testing', [
      'show_results',
      'test_resume',
      'start_test',
      'add_course_in_timer',
    ]),
    percent: function(required, total) {
      return 85;
      /*
      if (required<total) {
        return Math.round((Number(required)/Number(total) || 1)*100, 0);
      } else return 100;
      */
    },
    show_test() {
      this.RESET_LESSONS();
      this.add_course_in_timer();

      if (this.test_started) {
        this.test_resume();
      } else {
        this.start_test();
      }
    },
  },
};
</script>
